import React, { Component } from "react";
import Header from "../header";
import { Link } from "react-router-dom";
import SelectedRugsSidebar from "./selectedRugsSiderbar";
import SelectedRugsMobileSidebar from "./selectedRugsMobileSidebar";
import SimilarRugsSidebar from "./similarRugsSidebar";
import SimilarRugsMobileSidebar from "./similarRugsMobileSidebar";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import AfshanRug from "./rugTemplates/afshanRug";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import RugAPI from "../../api/rug";
import Footer from "../footer";
import RugSellersRow from "./rugSellersRow";
import { getRugTypeID } from "../../utilities/functions";
import ImageRugs from "./rugTemplates/imageRugs";
import RugCity from "./filters/city";
import ModernRug from "./rugTemplates/modernRug";
import RugHeaderPanel from "./rugHeaderPanel";
import YourPicrureRug from "./rugTemplates/yourPicrureRug";

import Cropper from "react-easy-crop";
import Modal from "react-modal";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import { getCroppedImg } from "../../utilities/canvasUtils";
import zIndex from "@material-ui/core/styles/zIndex";
import { round } from "lodash-es";

export default class RugsPreview extends Component {
  state = {
    rugs: [],
    selectedRug: {},
    selectedRugIndex: 0,
    similarRugsLoaded: false,
    similarRugs: [],
    activeSimilarRugs: [],
    sellers: [],
    selectedCities: [],
    sellersOrder: "on_sale",
    sellersRugId: 0,
    sellersLoading: true,
    show3D: false,
    widthPercent: "60%",
    rotate: false,
    isDragging: false,
    x: 174,
    y: 680,
    offsetX: 0,
    offsetY: 0,
    // image crop/upload state
    cropModal: false,
    imgUriPreview: null,
    crop: { x: 0, y: 0 },
    rotation: 0,
    zoom: 1,
    croppedAreaPixels: null,
    croppedImage: null,
    aspect: 4 / 3,
    defaultImage: "",
    backgroundImage: "",
    // 3D control state
    perspective: 800,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    scale: 1.1,
    controlDragging: false,
    controlType: null,
    controlStartX: 0,
    controlStartY: 0,
  };

  fileInputRef = React.createRef();
  imgRef = React.createRef();
  previewCanvasRef = React.createRef();

  handleSelectedSimilarRugs = () => {
    this.setState({
      activeSimilarRugs: this.state.similarRugs[this.state.selectedRugIndex],
    });
  };

  loadSellers = (rugID) => {
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getRugSellers(rugID, this.state.sellersOrder, this.state.selectedCities)
      .then((response) => {
        if (response.success) {
          this.setState({ sellers: response.data.results });
        }
        this.setState({ sellersLoading: false });
      });
  };

  loadSimilarRugs = () => {
    let similarRugs = [];

    this.state.rugs.map((rug, i) => {
      const rugAPIObj = new RugAPI();
      const toranj = rug.toranj ? rug.toranj.id : 0;
      const corner = rug.corner ? rug.corner.id : 0;
      const border = rug.border ? rug.border.id : 0;
      const tile = rug.tile ? rug.tile.id : 0;
      const background = rug.background ? rug.background.id : 0;
      const pattern = rug.pattern ? rug.pattern.id : 0;

      const rugTypeID = getRugTypeID(rug.type);
      rugAPIObj
        .findRug(rugTypeID, toranj, corner, tile, background, border, pattern)
        .then((response) => {
          if (response.success) {
            similarRugs[i] = response.data;
          } else {
            similarRugs[i] = [];
          }
          this.setState({ similarRugs: similarRugs }, () =>
            this.handleSelectedSimilarRugs()
          );
        });
      return "";
    });
  };

  //   addLogs = (rugs) => {
  //     let ids = [];
  //     rugs.map((rug) => {
  //       const rugAPIObj = new RugAPI();
  //       rug.toranj && ids.push(rug.toranj.id);
  //       rug.corner && ids.push(rug.corner.id);
  //       rug.border && ids.push(rug.border.id);
  //       rug.tile && ids.push(rug.tile.id);
  //       rug.background && ids.push(rug.background.id);
  //       rug.pattern && ids.push(rug.pattern.id);

  //       const rugTypeID = getRugTypeID(rug.type);
  //       rugAPIObj.addLog(rugTypeID, ids);
  //       return null;
  //     });
  //   };


  updateWidth = () => {
    const w = window.innerWidth;

    // فرمول خطی: از 60% تا 100% بین 400px و 1600px
    const minW = 400;
    const maxW = 1600;

    // محدود کردن بین min و max
    const clamped = Math.max(minW, Math.min(w, maxW));

    // محاسبه درصد: وقتی w=maxW → 60% ، وقتی w=minW → 100%
    var percent = 60 + ((maxW - clamped) / (maxW - minW)) * 60;
    if (percent > 100) {
      percent = 100;
    }

    this.setState({ widthPercent: `${percent}%` });

    if (w < 992) {
      this.setState({ x: 30 });
      this.setState({ y: -230 });
    }
    else {
      this.setState({ x: 174 });
      this.setState({ y: 680 });
    }
  };

  componentDidMount() {
    if (
      this.props.context &&
      this.props.context.location.state &&
      this.props.context.location.state.rugs.length > 0
    ) {
      this.setState(
        {
          rugs: this.props.context.location.state.rugs,
          selectedRug: this.props.context.location.state.rugs[0],
        },
        () => this.loadSimilarRugs()
      );
      //   this.addLogs(this.props.context.location.state.rugs);
    } else {
      this.props.context.history.push("/generator");
    }
    window.addEventListener("resize", this.updateWidth);
    this.updateWidth(); // initialize on mount
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  rugClickHandler = (rug, index) => {
    this.setState({ selectedRug: rug, selectedRugIndex: index }, () => {
      if (rug.id && rug.id > 0) {
        if (this.state.sellersRugId !== rug.id) {
          this.setState({ sellersRugId: rug.id, sellersLoading: true });
          this.loadSellers(rug.id);
        }
      } else {
        this.handleSelectedSimilarRugs();
      }
    });
  };

  orderHandler = (order) => {
    if (order !== this.state.sellersOrder && this.state.selectedRug.id) {
      this.setState({ sellersOrder: order }, () =>
        this.loadSellers(this.state.sellersRugId)
      );
    }
  };

  show3DHandler = () => {
    this.setState({ show3D: !this.state.show3D });
  };
  backBtnHandler = () => {
    // this.setState({ show3D: !this.state.show3D });
  };

  addOrRemoveFromArray = (arr, value) => {
    let finalArray = arr;
    if (arr.indexOf(value) === -1) {
      finalArray.push(value);
    } else {
      finalArray.splice(finalArray.indexOf(value), 1);
    }
    return finalArray;
  };

  changeCitiesHandler = (cityID) => {
    const newData = this.addOrRemoveFromArray(
      this.state.selectedCities,
      cityID
    );
    this.setState(
      { selectedCities: newData, sellers: [] },
      this.loadSellers(this.state.sellersRugId)
    );
  };

  rotateHandler = evt => {
    this.setState({ rotate: !this.state.rotate });
  };

  openFileDialog = () => {
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  onSelectFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      this.setState({ imgUriPreview: reader.result, cropModal: true });
    });
    reader.readAsDataURL(file);
  };

  handleCropChange = (crop) => {
    this.setState({ crop });
  };

  onCropComplete = (_croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels });
  };

  handleZoomChange = (zoom) => {
    this.setState({ zoom });
  };

  showCroppedImage = async () => {
    try {
      const { imgUriPreview, croppedAreaPixels, rotation } = this.state;
      if (!imgUriPreview || !croppedAreaPixels) return;
      const croppedImage = await getCroppedImg(imgUriPreview, croppedAreaPixels, rotation);
      // set cropped image and attach to selectedRug.full_image so preview updates
      this.setState({ croppedImage, cropModal: false });
      //const updated = { ...(this.state.selectedRug || {}), full_image: croppedImage };
      //this.setState({ selectedRug: updated });
      this.state.backgroundImage = croppedImage;
      this.setState({ backgroundImage: croppedImage });
    } catch (e) {
      console.error(e);
    }
  };

  // handleMouseDown = (e) => {
  //   this.setState({
  //     isDragging: true,
  //     offsetX: e.clientX - this.state.x,
  //     offsetY: e.clientY - this.state.y,
  //   });
  // };

  // handleMouseMove = (e) => {
  //   // Carpet dragging
  //   if (this.state.isDragging) {

  //     var y_set = 180;
  //     const w = window.innerWidth;

  //     if (w > 992) {
  //       if (e.clientY - this.state.offsetY < 180) {
  //         y_set = 180;
  //       }
  //       else if (e.clientY - this.state.offsetY > 730) {
  //         y_set = 730;
  //       }
  //       else {
  //         y_set = e.clientY - this.state.offsetY;
  //       }
  //     } else {
  //       y_set = e.clientY - this.state.offsetY;
  //     }


  //     this.setState({
  //       x: e.clientX - this.state.offsetX,
  //       y: y_set,
  //     });
  //     return;
  //   }

  //   // 3D control dragging: adjust perspective/rotation based on controlType
  //   if (this.state.controlDragging && this.state.controlType) {
  //     const dx = e.clientX - this.state.controlStartX;
  //     const dy = e.clientY - this.state.controlStartY;
  //     const update = {};
  //     switch (this.state.controlType) {
  //       case "top":
  //         // vertical drag -> rotateX
  //         update.rotateX = Math.max(-90, Math.min(90, this.state.rotateX + dy * 0.2));
  //         break;
  //       case "right":
  //         // horizontal drag -> rotateY
  //         update.rotateY = Math.max(-90, Math.min(90, this.state.rotateY + dx * 0.2));
  //         break;
  //       case "bottom":
  //         // vertical drag -> rotateZ
  //         update.rotateZ = Math.max(-180, Math.min(180, this.state.rotateZ + dy * 0.2));
  //         break;
  //       case "left":
  //         // horizontal drag -> perspective
  //         update.perspective = Math.max(200, Math.min(2000, this.state.perspective + dx));
  //         break;
  //       default:
  //         break;
  //     }
  //     // update start positions for smooth continuous dragging
  //     update.controlStartX = e.clientX;
  //     update.controlStartY = e.clientY;
  //     this.setState(update);
  //   }
  // };

  // handleMouseUp = () => {
  //   this.setState({ isDragging: false, controlDragging: false, controlType: null });
  // };

  handleControlMouseDown = (e, type) => {
    e.stopPropagation();
    this.setState({
      controlDragging: true,
      controlType: type,
      controlStartX: e.clientX,
      controlStartY: e.clientY,
    });
  };

  handleControlMouseUp = (e) => {
    if (this.state.controlDragging) {
      this.setState({ controlDragging: false, controlType: null });
    }
  };

  // Desktop
  handleMouseDown = (e) => {
    this.setState({
      isDragging: true,
      offsetX: e.clientX - this.state.x,
      offsetY: e.clientY - this.state.y,
    });
  };

  handleMouseMove = (e) => {
    this.dragLogic(e.clientX, e.clientY);
  };

  handleMouseUp = () => {
    this.setState({ isDragging: false, controlDragging: false, controlType: null });
  };

  // Mobile
  handleTouchStart = (e) => {
    const touch = e.touches[0];
    this.setState({
      isDragging: true,
      offsetX: touch.clientX - this.state.x,
      offsetY: touch.clientY - this.state.y,
    });
  };

  handleTouchMove = (e) => {
    const touch = e.touches[0];
    this.dragLogic(touch.clientX, touch.clientY);
  };

  handleTouchEnd = () => {
    this.setState({ isDragging: false, controlDragging: false, controlType: null });
  };

  // Shared drag logic
  dragLogic = (clientX, clientY) => {
    if (this.state.isDragging) {
      let y_set = 180;
      const w = window.innerWidth;

      if (w > 992) {
        if (clientY - this.state.offsetY < 180) {
          y_set = 180;
        } else if (clientY - this.state.offsetY > 730) {
          y_set = 730;
        } else {
          y_set = clientY - this.state.offsetY;
        }
      } else {
        y_set = clientY - this.state.offsetY;
      }

      this.setState({
        x: clientX - this.state.offsetX,
        y: y_set,
      });
      return;
    }

    // 3D control dragging
    if (this.state.controlDragging && this.state.controlType) {
      const dx = clientX - this.state.controlStartX;
      const dy = clientY - this.state.controlStartY;
      const update = {};
      switch (this.state.controlType) {
        case "top":
          update.rotateX = Math.max(-90, Math.min(90, this.state.rotateX + dy * 0.2));
          break;
        case "right":
          update.rotateY = Math.max(-90, Math.min(90, this.state.rotateY + dx * 0.2));
          break;
        case "bottom":
          update.rotateZ = Math.max(-180, Math.min(180, this.state.rotateZ + dy * 0.2));
          break;
        case "left":
          update.perspective = Math.max(200, Math.min(2000, this.state.perspective + dx));
          break;
        default:
          break;
      }
      update.controlStartX = clientX;
      update.controlStartY = clientY;
      this.setState(update);
    }
  };





  render() {
    let selectedRug;
    let rugtype = this.state.selectedRug.id
      ? this.state.selectedRug.rug_type
      : this.state.selectedRug.type;
    switch (rugtype) {
      case "kheshti":
        selectedRug = (
          <KheshtiRug
            background={this.state.selectedRug.background}
            tile={this.state.selectedRug.tile}
            show={true}
          />
        );
        break;
      case "afshan":
        selectedRug = (
          <AfshanRug
            background={this.state.selectedRug.background}
            border={this.state.selectedRug.border}
            show={true}
          />
        );
        break;
      case "modern":
        selectedRug = (
          <ModernRug
            background={this.state.selectedRug.background}
            pattern={this.state.selectedRug.pattern}
            show={true}
          />
        );
        break;
      case "your_picture":
        selectedRug = (
          <YourPicrureRug
            background={this.state.selectedRug.background}
            pattern={this.state.selectedRug.pattern}
            show={true}
          />
        );
        break;
      default:
        selectedRug = (
          <LachakToranjRug
            background={this.state.selectedRug.background}
            border={this.state.selectedRug.border}
            corner={this.state.selectedRug.corner}
            toranj={this.state.selectedRug.toranj}
            show={true}
          />
        );
        break;
    }
    const customStyles = {
      content: {
        width: "100%",
        height: "100vh",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        padding: 0,
        zIndex: 99999,
        border: "none",
      },
    };

    return (
      <div className="body-3D">
        <Modal
          isOpen={this.state.cropModal}
          onRequestClose={() => {
            this.setState({ cropModal: false, croppedImage: "" });
          }}
          style={customStyles}
          overlayClassName={""}
          contentLabel="Example Modal"
        >
          <div className={"cropContainer"} style={{ zIndex: 9999 }}>
            <Cropper
              image={this.state.imgUriPreview}
              crop={this.state.crop}
              zoom={this.state.zoom}
              aspect={Number.isFinite(this.state.aspect) ? this.state.aspect : 4 / 3}
              onCropChange={this.handleCropChange}
              onCropComplete={this.onCropComplete}
              onZoomChange={this.handleZoomChange}
            />
          </div>
          <div className={"controls"}>
            <div className={"sliderContainer"}>
              <Typography variant="overline">
                {this.props.texts && this.props.texts.zoom}
              </Typography>
              <Slider
                value={this.state.zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="بزرگنمایی"
                onChange={(e, zoom) => this.setState({ zoom })}
                color="secondary"
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              style={{
                backgroundColor: "#06b170",
                color: "#fff",
                padding: 10,
                borderRadius: 4,
                zIndex: 9999,
              }}
              onClick={this.showCroppedImage}
            >
              <p>{this.props.texts && this.props.texts.image_registration}</p>
            </button>
          </div>
        </Modal>
        <input type="file" ref={this.fileInputRef} style={{ display: "none" }} accept=".gif,.jpg,.jpeg,.png" onChange={this.onSelectFile} />
        {/* Header */}
        <Header texts={this.props.texts} globalState={this.props.globalState} langHandler={this.props.langHandler} />
        {/* top background fot test 3D */}
        <div className="test-3D test-3D-light">

          <div className='rug-header-filter-mobile' style={{ width: this.state.widthPercent }}>
            {/* mobile mode */}
            <SelectedRugsMobileSidebar
              texts={this.props.texts}
              rugs={this.state.rugs}
              clickHandler={this.rugClickHandler}
            />
            <SimilarRugsMobileSidebar
              texts={this.props.texts}
              rugs={this.state.activeSimilarRugs}
              clickHandler={this.rugClickHandler}
            />
          </div>
          {/* desktop mode */}
          <RugHeaderPanel
            texts={this.props.texts}
            globalState={this.state}
            carpetTypeHandler={this.carpetTypeHandler}
            partsTabHandler={this.partsTabHandler}
            partSelectHandler={this.partSelectHandler}
            itemsScrollHandler={this.itemsScrollHandler}
          />
          <div className='rug-header-filter' style={{ width: this.state.widthPercent }}>
            <SelectedRugsSidebar
              texts={this.props.texts}
              rugs={this.state.rugs}
              clickHandler={this.rugClickHandler}
            />
            <SimilarRugsSidebar
              texts={this.props.texts}
              rugs={this.state.activeSimilarRugs}
              clickHandler={this.rugClickHandler}
            />
          </div>
          <div className="preview-body" style={{ width: this.state.widthPercent }}>

            <img
              className="background-3D"
              src=
              {
                this.state.backgroundImage != ''
                  ? this.state.backgroundImage
                  : "./static/img/3D-backgroundlight.png"
              }

              alt="cover"
            />
            {/* */}

            {/* Small 3D controls panel: appears bottom if side panel exists (widthPercent != 100%) */}
            {this.state.show3D && (() => {
              return (
                <div className="image-controller-3d">
                  <div>
                    <div>
                      <div className="co-title1" style={{ fontSize: 12 }}>{this.props.texts.preview_slider_prespective}</div>
                      <button
                        onClick={() => this.setState({ perspective: this.state.perspective - 1 })}
                        onDoubleClick={() => this.setState({ perspective: this.state.perspective - 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.61002C8.0901 4.32002 8.0901 3.84002 8.3801 3.55002C8.6701 3.26002 9.1501 3.26002 9.4401 3.55002L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z" fill="#353D57" />
                        </svg></button>
                      <div>
                        <span>{this.state.perspective}</span>
                        <input
                          type="range"
                          min="200"
                          max="2000"
                          step={1}
                          value={this.state.perspective}
                          onChange={(e) => this.setState({ perspective: Number(e.target.value) })}
                        />
                      </div>
                      <button
                        onClick={() => this.setState({ perspective: this.state.perspective + 1 })}
                        onDoubleClick={() => this.setState({ perspective: this.state.perspective + 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.9998 20.67C14.8098 20.67 14.6198 20.6 14.4698 20.45L7.94979 13.93C6.88979 12.87 6.88979 11.13 7.94979 10.07L14.4698 3.55002C14.7598 3.26002 15.2398 3.26002 15.5298 3.55002C15.8198 3.84002 15.8198 4.32002 15.5298 4.61002L9.00979 11.13C8.52979 11.61 8.52979 12.39 9.00979 12.87L15.5298 19.39C15.8198 19.68 15.8198 20.16 15.5298 20.45C15.3798 20.59 15.1898 20.67 14.9998 20.67Z" fill="#353D57" />
                        </svg>
                      </button>
                    </div>
                    <div>
                      <div className="co-title1" style={{ fontSize: 12 }}>{this.props.texts.preview_slider_size}</div>
                      <button
                        onClick={() => this.setState({ scale: Number(this.state.scale - 0.1) })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.61002C8.0901 4.32002 8.0901 3.84002 8.3801 3.55002C8.6701 3.26002 9.1501 3.26002 9.4401 3.55002L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z" fill="#353D57" />
                        </svg></button>
                      <div>
                        <span>
                          {this.state.scale.toFixed(1)}
                        </span>
                        <input
                          type="range"
                          min={0.5}
                          max={2.0}
                          value={this.state.scale}
                          step={0.1}
                          onChange={(e) => this.setState({ scale: Number(e.target.value) })}
                        />
                      </div>
                      <button
                        onClick={() => this.setState({ scale: Number(this.state.scale + 0.1) })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.9998 20.67C14.8098 20.67 14.6198 20.6 14.4698 20.45L7.94979 13.93C6.88979 12.87 6.88979 11.13 7.94979 10.07L14.4698 3.55002C14.7598 3.26002 15.2398 3.26002 15.5298 3.55002C15.8198 3.84002 15.8198 4.32002 15.5298 4.61002L9.00979 11.13C8.52979 11.61 8.52979 12.39 9.00979 12.87L15.5298 19.39C15.8198 19.68 15.8198 20.16 15.5298 20.45C15.3798 20.59 15.1898 20.67 14.9998 20.67Z" fill="#353D57" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div className="co-title" style={{ fontSize: 12 }}>{this.props.texts.preview_slider_angle_up_down}</div>
                      <button
                        onClick={() => this.setState({ rotateX: this.state.rotateX - 1 })}
                        onDoubleClick={() => this.setState({ rotateX: this.state.rotateX - 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.61002C8.0901 4.32002 8.0901 3.84002 8.3801 3.55002C8.6701 3.26002 9.1501 3.26002 9.4401 3.55002L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z" fill="#353D57" />
                        </svg></button>
                      <div>
                        <span>{this.state.rotateX}°</span>
                        <input
                          type="range"
                          min="-90"
                          max="90"
                          step={1}
                          value={this.state.rotateX}
                          onChange={(e) => this.setState({ rotateX: Number(e.target.value) })}
                        />
                      </div>
                      <button
                        onClick={() => this.setState({ rotateX: this.state.rotateX + 1 })}
                        onDoubleClick={() => this.setState({ rotateX: this.state.rotateX + 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.9998 20.67C14.8098 20.67 14.6198 20.6 14.4698 20.45L7.94979 13.93C6.88979 12.87 6.88979 11.13 7.94979 10.07L14.4698 3.55002C14.7598 3.26002 15.2398 3.26002 15.5298 3.55002C15.8198 3.84002 15.8198 4.32002 15.5298 4.61002L9.00979 11.13C8.52979 11.61 8.52979 12.39 9.00979 12.87L15.5298 19.39C15.8198 19.68 15.8198 20.16 15.5298 20.45C15.3798 20.59 15.1898 20.67 14.9998 20.67Z" fill="#353D57" />
                        </svg>
                      </button>
                    </div>
                    <div>
                      <div className="co-title" style={{ fontSize: 12 }}>{this.props.texts.preview_slider_angle_left_right}</div>
                      <button
                        onClick={() => this.setState({ rotateY: this.state.rotateY - 1 })}
                        onDoubleClick={() => this.setState({ rotateY: this.state.rotateY - 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.61002C8.0901 4.32002 8.0901 3.84002 8.3801 3.55002C8.6701 3.26002 9.1501 3.26002 9.4401 3.55002L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z" fill="#353D57" />
                        </svg></button>
                      <div>
                        <span>{this.state.rotateY}°</span>
                        <input
                          type="range"
                          min="-90"
                          max="90"
                          step={1}
                          value={this.state.rotateY}
                          onChange={(e) => this.setState({ rotateY: Number(e.target.value) })}
                        />
                      </div>
                      <button
                        onClick={() => this.setState({ rotateY: this.state.rotateY + 1 })}
                        onDoubleClick={() => this.setState({ rotateY: this.state.rotateY + 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.9998 20.67C14.8098 20.67 14.6198 20.6 14.4698 20.45L7.94979 13.93C6.88979 12.87 6.88979 11.13 7.94979 10.07L14.4698 3.55002C14.7598 3.26002 15.2398 3.26002 15.5298 3.55002C15.8198 3.84002 15.8198 4.32002 15.5298 4.61002L9.00979 11.13C8.52979 11.61 8.52979 12.39 9.00979 12.87L15.5298 19.39C15.8198 19.68 15.8198 20.16 15.5298 20.45C15.3798 20.59 15.1898 20.67 14.9998 20.67Z" fill="#353D57" />
                        </svg>
                      </button>
                    </div>
                    <div>
                      <div className="co-title" style={{ fontSize: 12 }}>{this.props.texts.preview_slider_rotate}</div>
                      <button
                        onClick={() => this.setState({ rotateZ: this.state.rotateZ - 1 })}
                        onDoubleClick={() => this.setState({ rotateZ: this.state.rotateZ - 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.61002C8.0901 4.32002 8.0901 3.84002 8.3801 3.55002C8.6701 3.26002 9.1501 3.26002 9.4401 3.55002L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z" fill="#353D57" />
                        </svg></button>
                      <div>
                        <span>{this.state.rotateZ}°</span>
                        <input
                          type="range"
                          min="-180"
                          max="180"
                          step={1}
                          value={this.state.rotateZ}
                          onChange={(e) => this.setState({ rotateZ: Number(e.target.value) })}
                        />
                      </div>
                      <button
                        onClick={() => this.setState({ rotateZ: this.state.rotateZ + 1 })}
                        onDoubleClick={() => this.setState({ rotateZ: this.state.rotateZ + 10 })}
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.9998 20.67C14.8098 20.67 14.6198 20.6 14.4698 20.45L7.94979 13.93C6.88979 12.87 6.88979 11.13 7.94979 10.07L14.4698 3.55002C14.7598 3.26002 15.2398 3.26002 15.5298 3.55002C15.8198 3.84002 15.8198 4.32002 15.5298 4.61002L9.00979 11.13C8.52979 11.61 8.52979 12.39 9.00979 12.87L15.5298 19.39C15.8198 19.68 15.8198 20.16 15.5298 20.45C15.3798 20.59 15.1898 20.67 14.9998 20.67Z" fill="#353D57" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })()}


            {/* carpet */}
            <div
              onMouseMove={this.handleMouseMove}
              onMouseUp={this.handleMouseUp}
              onTouchMove={this.handleTouchMove}
              onTouchEnd={this.handleTouchEnd}>
              <div
                onMouseDown={this.handleMouseDown}
                onTouchStart={this.handleTouchStart}
                style={{
                  position: "absolute",
                  left: this.state.x,
                  top: this.state.y,
                  cursor: "grab",
                  zIndex: 1,
                  height: "0px"
                }}
              >


                <div
                  className={`${this.state.show3D ? "carpet-3D preview-rotation-reverse" : "carpet-3D preview-rotation"}`}
                // onClick={this.show3DHandler}

                >
                  <div className="rotation-mobile-time"
                    style={{
                      transform: this.state.show3D
                        ? `perspective(${this.state.perspective}px) rotateX(${this.state.rotateX}deg) rotateY(${this.state.rotateY}deg) rotateZ(${this.state.rotateZ}deg)`
                        : "none",
                      transformStyle: "preserve-3d",
                      transition: "transform 250ms ease",
                      //display: "inline-block",
                      transformOrigin: "center center",
                      scale: `${this.state.scale}`,
                    }}
                  >
                    <div className="text-center before-body-carpet relative">
                      <div className={`body-carpet ${this.state.rotate ? "rotation-90" : "rotation-90-reverse"}`}
                      >
                        {this.state.selectedRug && this.state.selectedRug.full_image ? (
                          <ImageRugs image={this.state.selectedRug.full_image} />
                        ) : (
                          selectedRug
                        )}
                      </div>
                    </div>
                  </div>
                </div>



              </div>
            </div>


            <div className="body-filter-preview">
              {/* rotate */}
              <button className="btn-preview-3D" onClick={this.openFileDialog}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.00043 17.75C8.59043 17.75 8.25043 17.41 8.25043 17L8.25043 12.81L7.53043 13.53C7.24043 13.82 6.76043 13.82 6.47043 13.53C6.18043 13.24 6.18043 12.76 6.47043 12.47L8.47043 10.47C8.68043 10.26 9.01043 10.19 9.29043 10.31C9.57043 10.42 9.75043 10.7 9.75043 11L9.75043 17C9.75043 17.41 9.41043 17.75 9.00043 17.75Z" fill="#353D57" />
                  <path d="M11.0004 13.7499C10.8104 13.7499 10.6204 13.6799 10.4704 13.5299L8.47043 11.5299C8.18043 11.2399 8.18043 10.7599 8.47043 10.4699C8.76043 10.1799 9.24043 10.1799 9.53043 10.4699L11.5304 12.4699C11.8204 12.7599 11.8204 13.2399 11.5304 13.5299C11.3804 13.6799 11.1904 13.7499 11.0004 13.7499Z" fill="#353D57" />
                  <path d="M15 22.75L9 22.75C3.57 22.75 1.25 20.43 1.25 15L1.25 9C1.25 3.57 3.57 1.25 9 1.25L14 1.25C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75L9 2.75C4.39 2.75 2.75 4.39 2.75 9L2.75 15C2.75 19.61 4.39 21.25 9 21.25L15 21.25C19.61 21.25 21.25 19.61 21.25 15L21.25 10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10L22.75 15C22.75 20.43 20.43 22.75 15 22.75Z" fill="#353D57" />
                  <path d="M22 10.75L18 10.75C14.58 10.75 13.25 9.41999 13.25 5.99999L13.25 1.99999C13.25 1.69999 13.43 1.41999 13.71 1.30999C13.99 1.18999 14.31 1.25999 14.53 1.46999L22.53 9.46999C22.74 9.67999 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.80999L14.75 5.99999C14.75 8.57999 15.42 9.24999 18 9.24999L20.19 9.24999L14.75 3.80999Z" fill="#353D57" />
                </svg>
                <span>{this.props.texts.preview_btn_open_file_dialog}</span>
              </button>
              <button className="btn-preview-3D" onClick={this.show3DHandler}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9996 13.0802C11.8696 13.0802 11.7396 13.0502 11.6196 12.9802L6.31964 9.92019C5.95964 9.71019 5.83962 9.25019 6.04962 8.90019C6.25962 8.54019 6.70962 8.42019 7.07962 8.63019L11.9996 11.4802L16.8896 8.65019C17.2496 8.44019 17.7096 8.57019 17.9196 8.92019C18.1296 9.28019 17.9996 9.74019 17.6496 9.94019L12.3896 12.9802C12.2596 13.0402 12.1296 13.0802 11.9996 13.0802Z" fill="#353D57" />
                  <path d="M12 18.5201C11.59 18.5201 11.25 18.1801 11.25 17.7701L11.25 12.3301C11.25 11.9201 11.59 11.5801 12 11.5801C12.41 11.5801 12.75 11.9201 12.75 12.3301L12.75 17.7701C12.75 18.1801 12.41 18.5201 12 18.5201Z" fill="#353D57" />
                  <path d="M12.0002 18.7498C11.4202 18.7498 10.8503 18.6198 10.3903 18.3698L7.19025 16.5898C6.23025 16.0598 5.49023 14.7898 5.49023 13.6898L5.49023 10.2998C5.49023 9.20981 6.24025 7.9298 7.19025 7.3998L10.3903 5.6198C11.3103 5.1098 12.6902 5.1098 13.6102 5.6198L16.8102 7.3998C17.7702 7.9298 18.5103 9.19981 18.5103 10.2998L18.5103 13.6898C18.5103 14.7798 17.7602 16.0598 16.8102 16.5898L13.6102 18.3698C13.1502 18.6198 12.5802 18.7498 12.0002 18.7498ZM12.0002 6.7498C11.6702 6.7498 11.3502 6.8098 11.1202 6.9398L7.92026 8.7198C7.43026 8.9898 6.99023 9.7498 6.99023 10.2998L6.99023 13.6898C6.99023 14.2498 7.43026 14.9998 7.92026 15.2698L11.1202 17.0498C11.5802 17.3098 12.4202 17.3098 12.8802 17.0498L16.0802 15.2698C16.5702 14.9998 17.0103 14.2398 17.0103 13.6898L17.0103 10.2998C17.0103 9.73981 16.5702 8.9898 16.0802 8.7198L12.8802 6.9398C12.6502 6.8098 12.3302 6.7498 12.0002 6.7498Z" fill="#353D57" />
                  <path d="M15.0002 22.7502C14.7302 22.7502 14.4802 22.6002 14.3502 22.3702C14.2202 22.1302 14.2202 21.8502 14.3602 21.6102L15.4102 19.8602C15.6202 19.5102 16.0802 19.3902 16.4402 19.6002C16.8002 19.8102 16.9102 20.2702 16.7002 20.6302L16.4302 21.0802C19.1902 20.4302 21.2602 17.9502 21.2602 14.9902C21.2602 14.5802 21.6002 14.2402 22.0102 14.2402C22.4202 14.2402 22.7602 14.5802 22.7602 14.9902C22.7502 19.2702 19.2702 22.7502 15.0002 22.7502Z" fill="#353D57" />
                  <path d="M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.51999 1.4 9.64999 1.63C9.77999 1.87 9.78002 2.15 9.64001 2.39L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.4C7.2 4.19 7.08999 3.73 7.29999 3.37L7.57001 2.92C4.81001 3.57 2.73999 6.05 2.73999 9.01C2.74999 9.41 2.41 9.75 2 9.75Z" fill="#353D57" />
                </svg>
                <span>{this.props.texts.preview_btn_show_3d}</span>
              </button>
              <button className="btn-preview-3D btn-preview-3D-mob" onClick={this.rotateHandler}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.75 22.75L7.25 22.75C3.1 22.75 1.25 20.9 1.25 16.75L1.25 12.25C1.25 8.1 3.1 6.25 7.25 6.25L11.75 6.25C15.9 6.25 17.75 8.1 17.75 12.25L17.75 16.75C17.75 20.9 15.9 22.75 11.75 22.75ZM7.25 7.75C3.93 7.75 2.75 8.93 2.75 12.25L2.75 16.75C2.75 20.07 3.93 21.25 7.25 21.25L11.75 21.25C15.07 21.25 16.25 20.07 16.25 16.75L16.25 12.25C16.25 8.93 15.07 7.75 11.75 7.75L7.25 7.75Z" fill="#353D57" />
                  <path d="M22.0004 9.75C21.5904 9.75 21.2504 9.41 21.2504 9C21.2504 6.04 19.1904 3.56 16.4204 2.91L16.6904 3.36C16.9004 3.72 16.7904 4.18 16.4304 4.39C16.0704 4.6 15.6104 4.49 15.4004 4.13L14.3504 2.38C14.2104 2.15 14.2104 1.86 14.3404 1.63C14.4804 1.4 14.7304 1.25 15.0004 1.25C19.2704 1.25 22.7504 4.73 22.7504 9C22.7504 9.41 22.4104 9.75 22.0004 9.75Z" fill="#353D57" />
                </svg>
                <span>{this.props.texts.preview_btn_totate}</span>
              </button>
              {/* back */}
              <Link to={"/generator"}>
                <button className="back-to-page" onClick={this.backBtnHandler}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill="#353D57" />
                    <path d="M13.9199 16.13H8.9999C8.5899 16.13 8.2499 15.79 8.2499 15.38C8.2499 14.97 8.5899 14.63 8.9999 14.63H13.9199C15.1999 14.63 16.2499 13.59 16.2499 12.3C16.2499 11.01 15.2099 9.96997 13.9199 9.96997H7.1499C6.7399 9.96997 6.3999 9.62997 6.3999 9.21997C6.3999 8.80997 6.7399 8.46997 7.1499 8.46997H13.9199C16.0299 8.46997 17.7499 10.19 17.7499 12.3C17.7499 14.41 16.0299 16.13 13.9199 16.13Z" fill="#353D57" />
                    <path d="M8.56994 11.5201C8.37994 11.5201 8.18994 11.4501 8.03994 11.3001L6.46994 9.73007C6.17994 9.44007 6.17994 8.96007 6.46994 8.67007L8.03994 7.10007C8.32994 6.81007 8.80994 6.81007 9.09994 7.10007C9.38994 7.39007 9.38994 7.87007 9.09994 8.16007L8.05994 9.20007L9.09994 10.2401C9.38994 10.5301 9.38994 11.0101 9.09994 11.3001C8.95994 11.4401 8.76994 11.5201 8.56994 11.5201Z" fill="#353D57" />
                  </svg>

                </button>
              </Link>
            </div>
          </div>

        </div>
        {/* cards body */}
        <div className="cards-body" style={{ width: this.state.widthPercent }}>

          <div className="auth-modal-overlay-carpet">
            <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
              <form onSubmit={this.state.authMode === 'login' ? this.submitLogin : this.submitRegister}>
                <div className="auth-row">
                  <input name="authEmail" value={this.state.authEmail} onChange={this.handleAuthChange} placeholder={this.props.texts.order_input_command} />
                </div>
                <div className="auth-actions">
                  <button>{this.props.texts.order_btn_submit}</button>
                </div>
              </form>
            </div>
          </div>


        </div>
        {/* footer */}
        <Footer />

      </div>
    );
  }
}
